import { Flex } from "@chakra-ui/layout";
import { FormArrecadacaoChildrenFormProps } from "./FormArrecadacao";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { useState, useMemo, useEffect } from "react";
import { useLoading } from "ui/components/GlobalLoading";
import { Box, Text, Tag } from "@chakra-ui/react";
import { Row } from "antd";
import InputSearch from "components/Input/InputSearch";
import { Col } from "antd";
import Field from "ui/components/Input/Field";
import InputMoney from "components/Input/InputMoney/index";
import { FixedSizeList } from "react-window";
import useUnidadesSimplificado from "core/features/unidades/useUnidadesSimplificado";
import { FormaDistribuicaoArrecadacaoEnum } from "features/arrecadacoes/enums";
import useVariacoesUnidades from "core/features/arrecadacoes/useVariacoesUnidades";

function FormValorIndividual({
  current,
  control,
  watch,
  setValue,
  idArrecadacao,
}: FormArrecadacaoChildrenFormProps) {
  const form = watch();
  const { tenant } = useCurrentTenant();
  const { data: allUnidades, isLoading: isLoadingAllUnidades } =
    useUnidadesSimplificado(
      tenant.id,
      {
        limit: 99999,
        gruposUnidadesIds:
          form.formaDistribuicaoArrecadacaoId ===
            FormaDistribuicaoArrecadacaoEnum.GrupoUnidades && form.destinoId
            ? [form.destinoId]
            : undefined,
      },
      current
    );

  const { data: variacaoUnidades, isLoading: isLoadingIndexador } =
    useVariacoesUnidades(idArrecadacao, current);

  const [search, setSearch] = useState("");

  const _unidades = useMemo(
    () =>
      search
        ? allUnidades?.items?.filter(
            (unidade) =>
              unidade.numero.toLowerCase().includes(search?.toLowerCase()) ||
              unidade.blocoQuadra?.nome.includes(search?.toLowerCase())
          )
        : allUnidades?.items,
    [allUnidades?.items, search]
  );

  useLoading(isLoadingAllUnidades || isLoadingIndexador);

  useEffect(() => {
    if (variacaoUnidades?.length) {
      const valoresManuais = variacaoUnidades.reduce((acc, next) => {
        acc[next.unidadeId] = next.valor;
        return acc;
      }, {} as Record<string, number>);

      setValue("valorManualUnidades", valoresManuais);
    }
  }, [variacaoUnidades, setValue]);

  const item = useMemo(
    () =>
      ({ index, style }: { index: number; style: any }) => {
        const _unidade = _unidades?.[index];
        return (
          <Flex
            h={"50px"}
            as={Row}
            gutter={16}
            key={_unidade?.id}
            alignItems="center"
            borderBottomWidth={1}
            borderBottomColor="gray.100"
            style={style}
          >
            <Box as={Col} sm={18}>
              <Flex gap={2} alignItems="center">
                {_unidade?.blocoQuadra ? (
                  <Flex mt="2px" fontSize="12px" fontWeight="bold">
                    <Tag> {_unidade?.blocoQuadra.nome}</Tag>
                  </Flex>
                ) : null}

                <Flex> {_unidade?.numero}</Flex>
              </Flex>
            </Box>

            <Box as={Col} sm={6}>
              <Field
                name={`valorManualUnidades.${_unidade?.id}`}
                control={control}
                render={({ field, isInvalid }) => (
                  <InputMoney isInvalid={isInvalid} {...field} />
                )}
              />
            </Box>
          </Flex>
        );
      },
    [_unidades, control]
  );

  return (
    <Flex
      display={current ? undefined : "none"}
      flexDir="column"
      flex={1}
      w="100%"
    >
      <Text mb={2} fontSize={16} fontWeight="medium">
        Insira o valor de cada unidade
      </Text>
      <InputSearch
        defaultValue={search}
        onSearch={(q) => setSearch(q ?? "")}
        placeholder="Pesquisar unidade ou proprietário"
        maxW="100%"
      />

      <Box
        as={Row}
        gutter={16}
        mt={4}
        mb={1}
        borderBottomWidth={1}
        borderBottomColor="gray.100"
      >
        <Box as={Col} sm={18}>
          <Text>Unidade</Text>
        </Box>

        <Box as={Col} sm={6}>
          <Text textAlign="right" mr={9}>
            Valor
          </Text>
        </Box>
      </Box>

      <FixedSizeList
        itemCount={_unidades?.length ?? 0}
        itemSize={50}
        height={440}
        width="100%"
        className="custom-scroll-bar"
      >
        {item}
      </FixedSizeList>
    </Flex>
  );
}

export default FormValorIndividual;
